// @flow
/* eslint react/forbid-prop-types:0 */
/* eslint react/jsx-no-bind:0 */

import React, { Component } from 'react';
import Image from 'app/common/react/components/growth/unauth/Image/Image';
import PinImageHover from 'app/common/react/components/growth/unauth/pin/PinImage/PinImageHover';
import PropTypes from 'prop-types';
import type { ContextType } from 'app/common/react/components/growth/unauth/lib/PropTypes';
import { compose } from 'redux';
import hoverable, { type hoverHandlersType } from 'app/common/lib/react/hoverable';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';
import { Box, Button } from 'gestalt';

type State = {
  toggled: boolean,
};

type Props = {
  anchorTitle: string,
  imageDescription: string,
  image: Object,
  imageWidthMax: number,
  hoverHandlers: hoverHandlersType,
  isHovering: boolean,
  requestContext: RequestContextType,
  link: string,
  title: string,
  buttonText: string,
  overlayText?: string,
};

const styles = {
  brioContainer: {
    position: 'relative',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  title: {
    fontSize: '25px',
    color: 'white',
    marginTop: '10px',
    fontWeight: 'normal',
  },
  btn: {
    color: 'white',
  },
  dimOverlayDark: {
    cursor: 'pointer',
    opacity: 0.55,
    bottom: '0px',
    left: '0px',
    right: '0px',
    top: '0px',
    backgroundColor: '#000',
    borderRadius: '6px 6px 0 0',
    position: 'absolute',
    WebkitTransition: 'opacity .04s linear',
    transition: 'opacity .04s linear',
    pointerEvents: 'none',
  },
};

class HolidayCard extends Component<Props, State> {
  context: ContextType;

  handleClick = (e: SyntheticMouseEvent<>) => {
    e.preventDefault();
    const isPressingCmdOrWinKey = e.metaKey;

    const target = !isPressingCmdOrWinKey ? '_self' : '_blank';

    const win = window.open(this.props.link, target);
    win.focus();
  };

  handleImageClick = () => {};

  render() {
    const {
      anchorTitle,
      imageDescription,
      hoverHandlers,
      image,
      imageWidthMax,
      title,
      buttonText,
      overlayText = '',
      link,
    } = this.props;

    const imageHeight = (image.height * imageWidthMax) / image.width;

    const srcUrl = image.url;

    const imageComponent = (
      <Image alt={imageDescription} lazyLoad={false} src={srcUrl} style={{ height: imageHeight }} />
    );

    const pinFigure = (
      <React.Fragment>
        <Box
          direction="column"
          display="flex"
          height={imageHeight}
          width={image.width}
          position="absolute"
        >
          <Box padding={4} flex="grow">
            {/* eslint-disable react/no-danger */}
            <span style={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
            {/* eslint-enable react/no-danger */}
          </Box>
          <Box padding={2}>
            <Button text={buttonText} />
          </Box>
        </Box>

        {imageComponent}
        {this.props.isHovering && (
          <React.Fragment>
            <div style={styles.dimOverlayDark} />
            <PinImageHover handleImageClick={this.handleImageClick} textOverride={overlayText} />
          </React.Fragment>
        )}
      </React.Fragment>
    );
    return (
      /* eslint-disable jsx-a11y/click-events-have-key-events */
      <div
        {...hoverHandlers}
        onClick={(e) => {
          this.handleClick(e);
        }}
        onContextMenu={(e) => {
          e.stopPropagation();
        }}
        role="button"
        tabIndex="0"
        style={styles.brioContainer}
      >
        {/* eslint-enable jsx-a11y/click-events-have-key-events */}
        <a href={link} target={'_self'} title={anchorTitle}>
          {pinFigure}
        </a>
      </div>
    );
  }
}

HolidayCard.propTypes = {
  anchorTitle: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  imageDescription: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  imageWidthMax: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

HolidayCard.contextTypes = {
  pageType: PropTypes.string.isRequired,
  unauthId: PropTypes.string.isRequired,
  userAgent: PropTypes.shape({
    canUseNativeApp: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
  }).isRequired,
};

export default compose(
  hoverable,
  withRequestContext,
)(HolidayCard);
